<div class="submit-offer-dialog">
  <h2 mat-dialog-title>
    {{ data.title }}
  </h2>

  <mat-dialog-content>
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="formFields" [model]="formModel">
      </formly-form>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ 'form.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="filteredLocations.length === 0 || form.invalid">
      {{ data.submitButtonLabel }}
    </button>
  </mat-dialog-actions>
</div>
